<template>
  <div class="tags">
    <el-row :gutter="20">
      <el-col :span="24">
        <el-card>
          <h1>标签管理</h1>
          <div class="tag-management">
            <el-row :gutter="20">
              <el-col :span="6">
                <el-button type="primary" @click="handleAdd">新增标签</el-button>
              </el-col>
              <el-col :span="6">
                <el-button type="danger" @click="handleDelete">删除标签</el-button>
              </el-col>
              <el-col :span="6">
                <el-input
                  v-model="searchQuery"
                  placeholder="搜索标签名称或描述"
                  clearable
                  @clear="handleSearchClear"
                  empty-text="暂无标签"
                />
              </el-col>
              <el-col :span="6">
                <el-button type="primary">AI描述生成</el-button>
              </el-col>
            </el-row>

            <el-table
              :data="filteredTags"
              style="width: 100%; margin-top: 20px;"
              @selection-change="handleSelectionChange"
              empty-text="暂无标签"
            >
              <el-table-column type="selection" width="55" />
              <el-table-column prop="id" label="标签 ID" sortable />
              <el-table-column prop="name" label="标签名称" sortable />
              <el-table-column prop="description" label="描述" />
              <el-table-column prop="borrowed" label="使用状态" sortable >
                <template #default="scope">
                  <el-tag :type="scope.row.borrowed ? 'danger' : 'success'">
                    {{ scope.row.borrowed ? '使用中' : '未使用' }}
                  </el-tag>
                </template>
              </el-table-column>
              <el-table-column prop="borrower" label="使用人" />
              <el-table-column prop="location" label="位置" />
              <el-table-column label="操作">
                <template #default="scope">
                  <el-button type="text" @click="handleEdit(scope.row)">编辑</el-button>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </el-card>
      </el-col>
    </el-row>

    <!-- 新增/编辑弹框 -->
    <el-dialog
      v-model="dialogVisible"
      :title="editMode ? '编辑标签' : '新增标签'"
      width="30%"
    >
      <el-form :model="newTag" label-width="100px">
        <el-form-item label="标签 ID">
          <el-input v-model="newTag.id" disabled />
        </el-form-item>
        <el-form-item label="标签名称">
          <el-input v-model="newTag.name" placeholder="请输入标签名称" />
        </el-form-item>
        <el-form-item label="描述">
          <el-input v-model="newTag.description" placeholder="请输入描述" />
        </el-form-item>
        <el-form-item label="使用状态">
          <el-select v-model="newTag.borrowed" @change="handleStatusChange">
            <el-option label="未使用" :value="false" />
            <el-option label="使用中" :value="true" />
          </el-select>
        </el-form-item>
        <el-form-item v-if="newTag.borrowed" label="使用人">
          <el-input v-model="newTag.borrower" placeholder="请输入使用人" />
        </el-form-item>
        <el-form-item label="位置">
          <el-input v-model="newTag.location" placeholder="请输入位置" />
        </el-form-item>
      </el-form>
      <template #footer>
        <span class="dialog-footer">
          <el-button @click="handleCancelAdd">取消</el-button>
          <el-button type="primary" @click="handleConfirmAdd">确认</el-button>
        </span>
      </template>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: 'TagManagement',
  data() {
    return {
      tags: [
        { id: '001', name: '红楼梦', description: '中国古典四大名著之一，由曹雪芹著。', borrowed: true, borrower: '吴勇', location: 'A区-1书架-3层' },
        { id: '002', name: '机器人时代', description: '探讨人工智能对社会的影响，作者是马丁·福特。', borrowed: false, borrower: '', location: 'A区-3书架-1层' },
        { id: '003', name: '人类简史', description: '尤瓦尔·赫拉利的著作，讲述了人类从认知革命到农业革命的历史。', borrowed: true, borrower: '陈超', location: 'B区-1书架-2层' },
        { id: '004', name: '蒙娜丽莎的微笑', description: '沃尔特·艾萨克森撰写的关于达芬奇的传记。', borrowed: false, borrower: '', location: 'C区-5书架-4层' },
        { id: '005', name: '世界尽头与冷酷仙境', description: '村上春树的代表作之一，讲述了两个精神世界的故事。', borrowed: true, borrower: '王芳', location: 'B区-4书架-5层' },
        { id: '006', name: '苏菲的世界', description: '乔斯坦·贾德著，一部关于哲学知识的小说。', borrowed: false, borrower: '', location: 'C区-5书架-1层' },
        { id: '007', name: '心理学与生活', description: '理查德·格里格和菲利普津巴多合著的心理学入门书籍。', borrowed: true, borrower: '孙丽', location: 'A区-3书架-2层' },
        { id: '008', name: '富国穷国俱乐部', description: '作者是约瑟夫·E·斯蒂格利茨，讲述全球化背景下各国经济发展差异。', borrowed: false, borrower: '', location: 'C区-6书架-3层' },
        { id: '009', name: '白夜行', description: '东野圭吾的悬疑小说，讲述了女主角在白夜行中寻找真相的故事。', borrowed: true, borrower: '李敏', location: 'B区-2书架-4层' },
        { id: '010', name: '沉默的大多数', description: '王小广著，讨论了现代社会中某些群体的声音被忽视的问题。', borrowed: true, borrower: '周静', location: 'B区-3书架-5层' },
        { id: '011', name: '教育心理学', description: '陈会昌著，深入浅出地介绍了教育心理学的基本原理和应用。', borrowed: true, borrower: '王伟', location: 'D区-2书架-1层' },
        { id: '012', name: '深入浅出计算机组成原理', description: '杨晓峰、雷和明编著，帮助读者理解计算机的工作原理。', borrowed: true, borrower: '林涛', location: 'B区-1书架-2层' },
        { id: '013', name: '建筑的历史', description: '弗兰克·劳埃德·赖特的著作，介绍了建筑历史的演变过程。', borrowed: true, borrower: '郑杰', location: 'A区-3书架-3层' },
        { id: '014', name: '音乐的哲学', description: '罗伯特·夏夫著，探讨了音乐的美学和哲学意义。', borrowed: false, borrower: '', location: 'D区-4书架-4层' },
        { id: '015', name: '电影理论', description: '大卫·波德维尔和克里斯汀·汤普森合著，深入分析电影艺术的基本理论。', borrowed: true, borrower: '赵强', location: 'A区-1书架-5层' }
      ],
      searchQuery: '',
      selectedTags: [],
      dialogVisible: false,
      editMode: false,
      newTag: {
        id: '',
        name: '',
        description: '',
        borrowed: false,
        borrower: '',
        location: ''
      }
    };
  },
  computed: {
    filteredTags() {
      return this.tags.filter(tag => {
        return tag.id.includes(this.searchQuery) || tag.name.includes(this.searchQuery) || tag.description.includes(this.searchQuery);
      });
    }
  },
  methods: {
    handleAdd() {
      const newId = String(this.tags.length + 1).padStart(3, '0');
      this.newTag = {
        id: newId,
        name: '',
        description: '',
        borrowed: false,
        borrower: '',
        location: ''
      };
      this.dialogVisible = true;
      this.editMode = false;
    },
    handleConfirmAdd() {
      if (this.newTag.borrowed && !this.newTag.borrower) {
        this.$message.error("请输入使用人");
        return;
      }
      if (this.editMode) {
        const index = this.tags.findIndex(tag => tag.id === this.newTag.id);
        if (index !== -1) {
          this.tags.splice(index, 1, { ...this.newTag });
          this.$message.success(`标签 ${this.newTag.id} 信息已更新`);
        }
      } else {
        this.tags.push({ ...this.newTag });
        this.$message.success(`新增标签 ${this.newTag.id} 成功`);
      }
      this.dialogVisible = false;
    },
    handleStatusChange(status) {
      if (!status) {
        this.newTag.borrower = '';
      }
    },
    handleCancelAdd() {
      this.dialogVisible = false;
    },
    handleDelete() {
      if (this.selectedTags.length === 0) {
        this.$message.warning('请选择要删除的标签');
        return;
      }
      this.tags = this.tags.filter(tag => !this.selectedTags.some(selected => selected.id === tag.id));
      this.selectedTags = [];
      this.$message.success('删除标签成功');
    },
    handleSearchClear() {
      this.searchQuery = '';
    },
    handleSelectionChange(selection) {
      this.selectedTags = selection;
    },
    handleEdit(row) {
      this.newTag = { ...row };
      this.dialogVisible = true;
      this.editMode = true;
    }
  }
};
</script>

<style scoped>
.tags {
  padding: 20px;
}

.tag-management {
  margin-top: 20px;
}
</style>
